import { gql } from '@apollo/client';

export const GET_LAST_FOUR_NOTIFICATIONS_BY_USER = gql`
  query getLastFourNotifications($userId: ID!) {
    getNotificationsByUser(userId: $userId, paginationOptions: { limit: 4, offset: 0 }) {
      edges {
        node {
          id
          text
          header
          icon
          acked
          createdAt
        }
      }
    }
  }
`;
